/**
 * Global motion rhythm tokens — keep every animation on the same cadence.
 * Durations 0.3–0.5s, ease-out entrances. Animate transform/opacity only.
 * Consumers must still gate on `useReducedMotion()` (see Reveal/CountUp).
 */

const EASE_OUT = [0.22, 1, 0.36, 1];

export const reveal = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE_OUT } },
};

export const revealUpSmall = {
    hidden: { opacity: 0, y: 12 },
    show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: EASE_OUT } },
};

/** Parent that staggers its children's entrance. Pair with `reveal` on children. */
export const staggerParent = {
    hidden: {},
    show: { transition: { staggerChildren: 0.06, delayChildren: 0.05 } },
};

/** Subtle press feedback for interactive cards/buttons. */
export const pressable = {
    whileHover: { y: -4, transition: { duration: 0.2, ease: EASE_OUT } },
    whileTap: { scale: 0.97 },
};
